import fs from 'fs';
import Path from 'path';
import { createModule } from './create-module.js';
/**
  * init main structure for modules.
  * @param name   - name of  main module .
  * @param path   - path for init module , by defulte (./) 
  * @param isAuth - if need to add auth module
  */
export const initModules = (name, path, isAuth, i18n) => {
  // main module dir
  const modulePath = Path.resolve(process.cwd(), path, "modules");
  ///////////////////////////////////////////////////////////
  // recursive : true for not throw error in dir not exest 
  // if not exest it will add in parent dir
  ///////////////////////////////////////////////////////
  fs.mkdirSync(modulePath, { recursive: true });
  // app module-
  // create main module
  const main_module_conf = {
    targetPath: `${path}/modules`,
    moduleName: name,
    isPages: false,
    isStore: true,
    isLayout: true,
    i18n: i18n
  }
  createModule(main_module_conf)
  // create auth module if needed
  if (isAuth) {
    const auth_conf = {
      targetPath: `${path}/modules`,
      moduleName: "auth",
      isPages: true,
      isStore: true,
      isLayout: true,
      i18n: i18n
    }
    createModule(auth_conf)
  }
}